/**
 * AWS Cognito SRP Authentication
 * Simple SRP authentication for password security
 */

import { srpLogin, respondToMfaChallenge } from "./srpLogin.js";

const newPoolData = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "",
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "",
};


export const signInNew = (username, password) => {

  return new Promise(async (resolve, reject) => {
    try {
      const tokens = await srpLogin({
        region: process.env.REACT_APP_AWS_REGION,
        userPoolId: newPoolData.UserPoolId,
        clientId: newPoolData.ClientId,
        username: username,
        password: password,
      });

      resolve(tokens);
    } catch (error) {
      reject(error);
    }
  });
};


// Wrapper: completes the MFA step (username/session from the MFA_REQUIRED result, code = user's OTP).
export const respondMfaNew = ({ username, session, code, challengeName }) => {
  return respondToMfaChallenge({
    region: process.env.REACT_APP_AWS_REGION,
    clientId: newPoolData.ClientId,
    username,
    session,
    code,
    challengeName,
  });
};
